import React, { useContext } from "react"
import SlotCounter from "react-slot-counter"
import { AIStateContext } from "../providers/AIStateProvider.jsx"
import { Tooltip } from "@shopify/polaris"
import { useTranslation } from "react-i18next"

export const CreditsCostPreview = ({
	context,
	costEstimation = null,
	hideEstimationTilde = false,
}) => {
	const { aiState } = useContext(AIStateContext)
	const { t } = useTranslation()

	const atLeastOneAiOrder =
		context === "single"
			? aiState.aiOrders.length > 0
			: context === "multiple"
				? aiState.bulkAIOrders.length > 0
				: context === "pages"
					? true
					: false

	const totalCost =
		context === "single"
			? aiState.aiOrdersTotalCost
			: context === "multiple"
				? aiState.bulkAIOrdersTotalCost
				: context === "pages"
					? costEstimation
					: 0

	const loadingTotalCost =
		context === "single"
			? aiState.loadingAiOrdersTotalCost
			: context === "multiple"
				? aiState.loadingBulkAIOrdersTotalCost
				: context === "pages"
					? false
					: false

	const insufficientCredits = aiState.creditsAvailable < totalCost
	const showCostTooltip = context !== "pages"

	const creditsIcon = (
		<svg
			xmlns="http://www.w3.org/2000/svg"
			width="0.9rem"
			height="0.9rem"
			viewBox="0 0 24 24"
			style={{ color: "#fff" }}
		>
			<g fill="none" fillRule="evenodd">
				<path d="M24 0v24H0V0zM12.594 23.258l-.012.002l-.071.035l-.02.004l-.014-.004l-.071-.036c-.01-.003-.019 0-.024.006l-.004.01l-.017.428l.005.02l.01.013l.104.074l.015.004l.012-.004l.104-.074l.012-.016l.004-.017l-.017-.427c-.002-.01-.009-.017-.016-.018m.264-.113l-.014.002l-.184.093l-.01.01l-.003.011l.018.43l.005.012l.008.008l.201.092c.012.004.023 0 .029-.008l.004-.014l-.034-.614c-.003-.012-.01-.02-.02-.022m-.715.002a.023.023 0 0 0-.027.006l-.006.014l-.034.614c0 .012.007.02.017.024l.015-.002l.201-.093l.01-.008l.003-.011l.018-.43l-.003-.012l-.01-.01z"></path>
				<path
					fill="currentColor"
					d="M12 2C6.477 2 2 6.477 2 12s4.477 10 10 10s10-4.477 10-10S17.523 2 12 2m0 1a9 9 0 0 1-9 9a9 9 0 0 1 9 9a9 9 0 0 1 9-9a9 9 0 0 1-9-9"
				></path>
			</g>
		</svg>
	)
	const loadingIcon = (
		<svg
			xmlns="http://www.w3.org/2000/svg"
			style={{ display: "block" }}
			width="1rem"
			height="1rem"
			viewBox="0 0 24 24"
		>
			<circle cx="4" cy="12" r="3" fill="currentColor">
				<animate
					id="svgSpinners3DotsBounce0"
					attributeName="cy"
					begin="0;svgSpinners3DotsBounce1.end+0.25s"
					calcMode="spline"
					dur="0.6s"
					keySplines=".33,.66,.66,1;.33,0,.66,.33"
					values="12;6;12"
				></animate>
			</circle>
			<circle cx="12" cy="12" r="3" fill="currentColor">
				<animate
					attributeName="cy"
					begin="svgSpinners3DotsBounce0.begin+0.1s"
					calcMode="spline"
					dur="0.6s"
					keySplines=".33,.66,.66,1;.33,0,.66,.33"
					values="12;6;12"
				></animate>
			</circle>
			<circle cx="20" cy="12" r="3" fill="currentColor">
				<animate
					id="svgSpinners3DotsBounce1"
					attributeName="cy"
					begin="svgSpinners3DotsBounce0.begin+0.2s"
					calcMode="spline"
					dur="0.6s"
					keySplines=".33,.66,.66,1;.33,0,.66,.33"
					values="12;6;12"
				></animate>
			</circle>
		</svg>
	)

	return (
		<div
			style={{
				display: "flex",
				gap: "0.5rem",
				height: "2rem",
				opacity: atLeastOneAiOrder ? "1" : "0",
				transition: "opacity 0.777s ease-in-out",
			}}
		>
			{context !== "pages" && (
				<div
					style={{
						background: insufficientCredits ? "#ff0d0d" : "#111",
						padding: "0.2rem 0.5rem",
						borderRadius: "0.5rem",
						display: "flex",
						alignItems: "center",
						gap: "0.5rem",
						position: "relative",
					}}
				>
					<div
						style={{
							display: "flex",
							alignItems: "center",
							gap: "0.2rem",
						}}
					>
						{creditsIcon}
						<span style={{ fontSize: "0.85rem", color: "#fff" }}>
							{t("ai.credits_available")}:
						</span>
					</div>
					<span
						translate="no"
						style={{
							fontSize: "0.9rem",
							fontWeight: "500",
							fontFamily: "monospace",
							color: "#fff",
						}}
					>
						<SlotCounter value={aiState.creditsAvailable} />
					</span>

					<div
						className="shadow border"
						style={{
							opacity: aiState.loadingCreditsAvailable
								? "1"
								: "0",
							transition: "opacity 0.35s ease-in-out",
							position: "absolute",
							top: "-0.7rem",
							right: "-0.7rem",
							background: "#fff",
							padding: "0rem 0.4rem",
							borderRadius: "0.5rem",
							color: "#222",
						}}
					>
						{loadingIcon}
					</div>
				</div>
			)}

			<div
				style={{
					background:
						insufficientCredits && context === "pages"
							? "#ff0d0d"
							: "#111",
					padding: "0.2rem 0.5rem",
					borderRadius: "0.5rem",
					display: "flex",
					alignItems: "center",
					gap: "0.5rem",
					position: "relative",
				}}
			>
				<div
					style={{
						display: "flex",
						alignItems: "center",
						gap: "0.2rem",
						pointerEvents: "auto",
					}}
				>
					{creditsIcon}
					{showCostTooltip ? (
						<Tooltip
							content={
								<div
									style={{
										padding: "0.4rem 0.7rem",
										width: "15rem",
									}}
								>
									<p
										style={{
											fontSize: "0.9rem",
											color: "#333",
										}}
									>
										{t("ai.credits_shown_estimation")}
									</p>
								</div>
							}
						>
							<span
								className="info-underline"
								style={{ fontSize: "0.85rem", color: "#fff" }}
							>
								{t("ai.cost")}:
							</span>
						</Tooltip>
					) : (
						<span
							style={{ fontSize: "0.85rem", color: "#fff" }}
						>
							{t("ai.cost")}:
						</span>
					)}
				</div>
				<span
					translate="no"
					style={{
						fontSize: "0.9rem",
						fontWeight: "500",
						fontFamily: "monospace",
						color: "#fff",
					}}
				>
					{!hideEstimationTilde && (
						<span
							style={{ fontSize: "1rem", marginRight: "0.2rem" }}
						>
							~
						</span>
					)}
					<SlotCounter key={totalCost} value={totalCost} />
				</span>

				<div
					className="shadow border"
					style={{
						opacity: loadingTotalCost ? "1" : "0",
						transition: "opacity 0.35s ease-in-out",
						position: "absolute",
						top: "-0.7rem",
						right: "-0.7rem",
						background: "#fff",
						padding: "0rem 0.4rem",
						borderRadius: "0.5rem",
						color: "#222",
					}}
				>
					{loadingIcon}
				</div>
			</div>
		</div>
	)
}
